import { Component, Input, OnInit } from '@angular/core';
import { AbstractTransport } from '../../../../../models/abstract-transport.model';
import { BaryCardComponent } from '../../../components';
import { CurrencyPipe, NgIf } from '@angular/common';
import { Estimation } from '../../../../../models/estimation.model';
import { Transport } from '../../../../../models/transport.model';
import { TranslateModule } from '@ngx-translate/core';
import { TransportOrder } from '../../../../../models/transport-order.model';

@Component({
  selector: 'jhi-transport-card-bill',
  standalone: true,
  templateUrl: './transport-card-bill.component.html',
  styleUrls: ['./transport-card-bill.component.scss'],
  imports: [BaryCardComponent, CurrencyPipe, NgIf, TranslateModule],
})
export class TransportCardBillComponent implements OnInit {
  @Input() public transport!: AbstractTransport;

  public estimation?: Estimation;

  public ngOnInit(): void {
    if (this.transport instanceof Transport) {
      this.estimation = this.transport.estimation;
    }

    if (this.transport instanceof TransportOrder) {
      this.estimation = new Estimation({
        basePrice: this.transport.transportPrice,
        priceHT: this.transport.ht(),
        insurance: this.transport.insurance,
        gazoleTaxRate: this.transport.gazoleTaxRate,
        gazoleTaxAmount: this.transport.gazoleTax,
        pricingOptions: this.transport.pricingOptions(),
      });
    }
  }

  public isTransportOrder(): boolean {
    return this.transport instanceof TransportOrder;
  }

  public isTransport(): boolean {
    return this.transport instanceof Transport;
  }

  public get pricingOptions(): number {
    if (this.estimation?.pricingOptions) {
      return this.estimation?.pricingOptions?.reduce((price, it) => price + it.amount, 0);
    }
    return 0;
  }
}
